import { useUnit } from 'effector-react'
import { useParams } from 'react-router'
import { useSearchParams } from 'react-router-dom'

import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'
import { $creatorId } from '@/models/creators.ts'
import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context'
import { useMassMessage } from '@/modules/online-mass-messages/hooks/use-mass-message.ts'
import { MassMessageForm } from '@/modules/online-mass-messages/views/mass-message-form.tsx'

export const MassMessageEdit = () => {
  const creatorId = useUnit($creatorId)

  const { id } = useParams()
  const [searchParam] = useSearchParams()

  const isCopyMode = searchParam.has('copy')
  const isInfoMode = searchParam.has('info')

  const { data, isFetching } = useMassMessage({
    messageId: id,
    copy: searchParam.has('copy'),
    creatorId: creatorId!,
  })

  if (isFetching || !data) {
    return <DefaultPageSkeleton />
  }

  return (
    <div className="px-4 py-8 pb-14 xl:container lg:px-16 xl:mx-auto">
      <DefaultMessageMediaProvider>
        <MessageMediaQueryProvider>
          <MassMessageForm
            data={data}
            mode={isCopyMode ? 'copy' : isInfoMode ? 'info' : 'edit'}
          />
        </MessageMediaQueryProvider>
      </DefaultMessageMediaProvider>
    </div>
  )
}
